// VAT on alcoholic drinks. Menu prices already INCLUDE 20% VAT (nothing is added at checkout);
// the cart only shows how each price splits into the price without VAT and the VAT, which add back up to the price.
export const VAT_PERCENT = 20;

// The moment VAT started showing (the time this was deployed, UK time). Orders placed before it never show VAT.
// Keep in step with VAT_START_DATE in the PHP vat_helper.php files.
export const VAT_START_DATE = "2026-10-19 11:30:00";

// Past orders (order history): only orders placed at or after the go-live moment show VAT. The cart is always for a new order.
export const vatAppliesToOrder = (createdAt) => String(createdAt || "").slice(0, 19) >= VAT_START_DATE;

// Wine and Champagne (11), Spirit and Liqueur (12). Beer, Lager and Cider (9) is not included.
const VAT_CATEGORY_IDS = new Set([11, 12]);

export const itemHasVat = (item) => VAT_CATEGORY_IDS.has(Number(item?.category_id));

// Splits a VAT-inclusive price in pence so that net + vat is always exactly the price.
export function splitVat(inclusivePrice) {
  const cents = Math.round((Number(inclusivePrice) || 0) * 100);
  const vatCents = Math.round((cents * VAT_PERCENT) / (100 + VAT_PERCENT));
  return { net: (cents - vatCents) / 100, vat: vatCents / 100 };
}
